import { Injectable } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

/**
 * Grid tiers, kept in sync with $grid-breakpoints in global-scss/_bootstrap-variables.scss.
 */
export enum BaseBreakpoint {
  sm = 576,
  md = 768,
  lg = 992,
  xl = 1200,
  xxl = 1600,
  xxxl = 2000,
  full = 2540,
}

@Injectable({ providedIn: 'root' })
export class BaseViewportService {
  constructor(private breakpointObserver: BreakpointObserver) {}

  /**
   * Emits true while the viewport is narrower than the given tier.
   * Mirrors the media-breakpoint-down() mixin, hence the 0.02px offset.
   */
  isBelow(breakpoint: BaseBreakpoint): Observable<boolean> {
    return this.breakpointObserver.observe(this.maxWidthQuery(breakpoint)).pipe(
      map(({ matches }) => matches),
      distinctUntilChanged(),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  }

  /**
   * Synchronous variant, for use outside of a template binding.
   */
  isBelowNow(breakpoint: BaseBreakpoint): boolean {
    return this.breakpointObserver.isMatched(this.maxWidthQuery(breakpoint));
  }

  private maxWidthQuery(breakpoint: BaseBreakpoint): string {
    return `(max-width: ${breakpoint - 0.02}px)`;
  }
}
